import { motion } from "framer-motion"
import { ShieldCheck } from "lucide-react"

const facultyMembers = [
  { id: 1, name: "Expert Faculty", image: "/faculty/f14.jpeg" },
  { id: 2, name: "Expert Faculty", image: "/faculty/f11.jpeg" },
  { id: 3, name: "Expert Faculty", image: "/faculty/f15.jpeg" },
  { id: 4, name: "Expert Faculty", image: "/faculty/f6.jpeg" },
  { id: 5, name: "Expert Faculty", image: "/faculty/f13.jpeg" },
  { id: 6, name: "Expert Faculty", image: "/faculty/f12.jpeg" },
  { id: 7, name: "Prabhakar Chouti", image: "/faculty/f4.jpeg" },
  { id: 8, name: "Expert Faculty", image: "/faculty/f8.jpeg" },
  { id: 9, name: "Expert Faculty", image: "/faculty/f9.jpeg" },
  { id: 10, name: "Expert Faculty", image: "/faculty/f5.jpeg" },
  { id: 11, name: "Expert Faculty", image: "/faculty/f10.jpeg" },
  { id: 12, name: "Jagadish Sir", image: "/faculty/f2.jpeg" },
  { id: 13, name: "Expert Faculty", image: "/faculty/f16.jpeg" },
  { id: 14, name: "Expert Faculty", image: "/faculty/f7.jpeg" },
]

export default function FacultySection() {
  return (
    <section id="faculty" className="py-16 sm:py-24 bg-white overflow-hidden relative border-t border-slate-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 relative z-10">
        
        {/* Header - Compact & Elegant */}
        <div className="text-center mb-12 sm:mb-20 space-y-3">
           <motion.div 
             initial={{ opacity: 0, y: 10 }}
             whileInView={{ opacity: 1, y: 0 }}
             viewport={{ once: true }}
             className="flex items-center justify-center gap-3"
           >
              <div className="w-8 h-px bg-[#b48c36]/30" />
              <p className="text-[#b48c36] font-bold text-[10px] uppercase tracking-[0.4em]">Our Team</p>
              <div className="w-8 h-px bg-[#b48c36]/30" />
           </motion.div>
           <motion.h2 
             initial={{ opacity: 0, y: 10 }}
             whileInView={{ opacity: 1, y: 0 }}
             transition={{ delay: 0.1 }}
             viewport={{ once: true }}
             className="text-3xl sm:text-4xl font-serif font-medium text-slate-950 leading-tight"
           >
              Our Expert <span className="text-slate-400 font-light italic">Teachers & Mentors.</span>
           </motion.h2>
        </div>

        {/* Faculty Grid - 7 Columns on Desktop, 2 on Mobile */}
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-7 gap-x-4 gap-y-10 sm:gap-x-6 sm:gap-y-12 max-w-[1200px] mx-auto">
          {facultyMembers.map((member, i) => (
            <motion.div 
              key={member.id}
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{ 
                delay: i * 0.03, 
                duration: 0.5,
                ease: "easeOut"
              }}
              viewport={{ once: true }}
              className="group flex flex-col items-center"
            >
              <div className="relative">
                {/* Circular Profile Image */}
                <div className="w-24 h-24 sm:w-28 sm:h-28 md:w-32 md:h-32 rounded-full overflow-hidden border-2 border-slate-50 group-hover:border-[#b48c36]/40 transition-all duration-500 shadow-sm group-hover:shadow-xl relative bg-slate-50">
                  <img 
                    src={member.image} 
                    alt={member.name} 
                    className="w-full h-full object-cover transition-all duration-700 group-hover:scale-110"
                    onError={(e) => {
                      (e.target as HTMLImageElement).src = `https://ui-avatars.com/api/?name=${encodeURIComponent(member.name)}&background=f8fafc&color=b48c36&size=128`;
                    }}
                  />
                </div>
                
                {/* Subtle Hover Ring */}
                <div className="absolute inset-0 rounded-full border border-[#b48c36]/0 group-hover:border-[#b48c36]/20 transition-all duration-500 scale-110 group-hover:scale-100 pointer-events-none" />
              </div>
            </motion.div>
          ))}
        </div>

      </div>
    </section>
  )
}
